import { useProduct, useProductMediaImageGroupsFlow } from '../model'
import { MediaForm } from './Media'
import { MediaImageGroupsList } from './Media/MediaImageGroupsList'

export const MediaPage = () => {
    const media = useProductMediaImageGroupsFlow()
    const { isLoading, error } = useProduct()

    if (isLoading || error) {
        return null
    }
    return (
        <div className='relative w-full min-w-0 max-w-full flex flex-col md:flex-row gap-[20px] mb-[89px]'>
            <div className='order-2 md:order-none flex flex-col gap-3 items-start w-full min-w-0 max-w-full md:w-[60%]'>
                <MediaImageGroupsList state={media} />
            </div>
            <div className='order-1 md:order-none rounded-xl w-full min-w-0 max-w-full md:w-[40%] flex flex-col gap-4'>
                <MediaForm media={media} />
            </div>
        </div>
    )
}
